import "./calendar.css";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../hooks";
import { CalendarOutline } from "../../../../../assets";
import { DateRangeProps, OperationCalendarRangeProps } from "./calendar.props";
import { Modal } from "../../../../modal";
import { Edit } from "../../../../edit";

const OperationCalendarRange: React.FC<OperationCalendarRangeProps> = ({
  show,
  className,
  dateRange,
  setDateRange,
}) => {
  const { t } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [initialRange, setInitialRange] = useState<DateRangeProps>(dateRange);
  const [newDateRange, setNewDateRange] = useState<DateRangeProps>(dateRange);

  const handleCancel = () => {
    setDateRange(initialRange);
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setDateRange(newDateRange);
    setIsModalOpen(false);
  };

  useEffect(() => setInitialRange(dateRange), [dateRange]);

  return (
    <>
      {show && (
        <>
          <button
            className={`operation-calendar-button ${className}`}
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            <img
              className="operation-calendar-icon"
              src={CalendarOutline}
              alt="Icon Calendar"
            />
            <p>
              {dateRange.startDate} - {dateRange.endDate}
            </p>
          </button>

          <Modal
            title={t.components.operations.calendarRange.modal.title}
            open={isModalOpen}
            setOpen={setIsModalOpen}
            actions={[
              { type: "cancel", onClick: handleCancel },
              {
                text: t.components.operations.calendarRange.modal.ready,
                onClick: handleOk,
              },
            ]}
          >
            <Edit.CalendarRange
              dateRange={dateRange}
              setDateRange={setNewDateRange}
            />
          </Modal>
        </>
      )}
    </>
  );
};

export default OperationCalendarRange;
